<template>
  <div v-if="from === 'tg'" class="ww-webapp-filter">
    <textarea class="ww-pres-link" ref="presLink" v-text="presentationLink" />
    <button class="ww-tg-btn" @click="historyBack">
      <span class="iconify ww-back-icon" data-icon="mdi-chevron-left"></span>
    </button>
    <button class="ww-tg-btn" @click="copyPartnerLink">
      <span class="iconify ww-copy-icon" data-icon="mdi-content-copy"></span>
    </button>
    <div v-if="copy" class="ww-copy-block">Ссылка скопирована</div>
  </div>
  <div v-else class="personal-offer">
    <div class="container">
      <div class="flex items-center justify-center">
        <span>{{ personalOffer }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import Locale from '../../../services/locale'

export default {
  name: 'PersonalOffer',
  props: {
    localeService: Locale,
    presentationId: String,
  },
  computed: {
    personalOffer() {
      return this.localeService.getConstantTranslationByKey('personal-offer')
    },
    presentationLink() {
      const url = new URL(location.href)
      const { origin } = url
      const ids = url.searchParams.get('ids')
      return `${origin}/${this.presentationId}/0?ids=${ids}`
    },
  },
  data() {
    const currentUrl = new URL(location.href)
    const from = currentUrl.searchParams.get('from')
    return {
      from,
      copy: false,
    }
  },
  methods: {
    historyBack() {
      history.back()
    },
    async copyPartnerLink() {
      try {
        await navigator.clipboard.writeText(this.presentationLink)
      } catch {
        this.$refs.presLink.select()
        document.execCommand('copy')
      } finally {
        this.copy = true
        setTimeout(() => {
          this.copy = false
        }, 2000)
      }
    },
  },
}
</script>

<style scoped>
.personal-offer {
  text-transform: uppercase;
  padding: 5px 0px;
  height: 40px;
  font-family: Roboto;
  font-size: 14px;
  font-weight: bold;
  line-height: 2.14;
  letter-spacing: 2px;
  color: #484848;
  background-color: #f5f8fa;
  margin-bottom: 45px;
}

.ww-webapp-filter {
  display: flex;
  justify-content: space-between;
  color: white;
  font-family: Roboto;
  height: 7vh;
  margin: 10px;
  grid-template-columns: 1.1fr 0.1fr 1fr;
}

.ww-copy-btn {
  border: 2px solid #1867c0;
  color: #1867c0;
}
.ww-copy-block {
  position: fixed;
  bottom: 25vh;
  z-index: 1000;
  background-color: #1867c0;
  width: 80vw;
  left: 10vw;
  height: 6vh;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.3rem;
}
.ww-back-icon {
  width: 31px;
  height: 31px;
}
.ww-copy-icon {
  width: 25px;
  height: 25px;
}
.ww-tg-btn {
  width: 101px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 0.3rem;
  background-color: #1867c0;
}

.ww-pres-link {
  width: 1px;
  height: 1px;
  position: absolute;
}
</style>
